// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-progress-bar__progress[data-v-4a8944a3]{height:2px;background:#443fdb;transition:width .45s ease}", ""]);
// Exports
module.exports = exports;
